/** Login-URL, die nach der Anmeldung auf genau die angefragte Seite zurückführt. */
export const loginPathFor = (pathname: string, search = "", hash = "") => {
    const target = `${pathname}${search}${hash}`
    if (!pathname || pathname === "/" || pathname.startsWith("/login")) return "/login"
    return `/login?redirect=${encodeURIComponent(target)}`
}

/** Nur interne Pfade zulassen (kein Open Redirect, keine Schleife über /login). */
export const safeRedirect = (redirect: string | null | undefined) => {
    if (!redirect || !redirect.startsWith("/") || redirect.startsWith("//") || redirect.startsWith("/\\") || redirect.startsWith("/login")) return "/"
    return redirect
}
